import type { ContentBehaviorAnalyticsType } from 'types/api/diagnosisReportRefResponseType';

import '../../assets/styles/ws-report.scss';
import WsReportHourlyHeatmap from './WsReportHourlyHeatmap';
import WsReportSegmentCompletion from './WsReportSegmentCompletion';
import WsReportStepDwellTime from './WsReportStepDwellTime';
import WsReportStepFunnel from './WsReportStepFunnel';

import type { JSX } from 'react';

/**
 * 行動分析セクション（EV-report-analytics-01〜05）。
 * ステップ別ファネル・ステップ別滞在時間・デバイス/ブラウザ別完了率・時間帯×曜日ヒートマップを縦積みで表示する。
 * 各子コンポーネントは対象データが無い場合に自身の early return で `null` を返すため、
 * 本コンポーネントは 4 要素をラッパー無しで並べるだけにする（空の card が残るのを避けるため）。
 */
export default function WsReportBehaviorAnalytics(props: {
  behaviorAnalytics?: ContentBehaviorAnalyticsType | null;
}): JSX.Element | null {
  const { behaviorAnalytics } = props;
  if (!behaviorAnalytics) return null;

  return (
    <section className="section-statistical">
      <div className="container">
        <h3 className="title-section title-md">行動分析</h3>
        <WsReportStepFunnel steps={behaviorAnalytics.steps} />
        <WsReportStepDwellTime steps={behaviorAnalytics.steps} />
        <WsReportSegmentCompletion
          devices={behaviorAnalytics.devices}
          browsers={behaviorAnalytics.browsers}
        />
        <WsReportHourlyHeatmap hourlyHeatmap={behaviorAnalytics.hourlyHeatmap} />
      </div>
    </section>
  );
}
